
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mobiworkx/forgot-password",
      function () {
        return require("private-next-pages/mobiworkx/forgot-password.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mobiworkx/forgot-password"])
      });
    }
  